import Vue from 'vue';

export default function resetState(state, initialState) {
  Object.keys(initialState).forEach(key => {
    let type = typeof initialState[key];
    if (typeof initialState[key] === 'object') {
      if (initialState[key] === null) {
        state[key] = initialState[key];
      } else Vue.set(state, key, {});
    } else {
      state[key] = initialState[key];
    }
  });
}
